// extracted by mini-css-extract-plugin
module.exports = {"root":"Quote--root--2KQ7B","small":"Quote--small--2Uw7O","tail":"Quote--tail--8z9gf","image":"Quote--image--1CEii"};